module.exports = __webpack_public_path__ + "img/Bualuang.3fad6e95.png";